// Legal config for React web apps. Versions MUST match backend legal_consent.py.
export const LEGAL = {
  appName: 'Nimbus',
  termsVersion: '2026-10-13.1',
  privacyVersion: '2026-10-09',
  cookieVersion: '2026-10-09',
  minAge: 18,
  // Set false if the app sets no analytics/marketing cookies (banner then only offers essential + reject).
  hasNonEssentialCookies: false,
  routes: { terms: '/terms', privacy: '/privacy', cookies: '/cookies', refund: '/refund', pricing: '/pricing' },
  companyName: 'Headkey Software Technologies Private Limited',
  companyCin: 'U72900KA2019PTC130529',
  contactEmail: 'info@headkeysoftwaresolution.com',
  grievanceOfficer: 'Suhas Raju',
  // INR prices are inclusive of GST (same wording as BharatConnect); backend pricing.PRICE_NOTE.
  priceNote: 'inclusive of GST',
  cookieStorageKey: 'cookie_consent',
  // Headkey company-wide policies on the website, linked next to the app's own legal pages (Suhas, 9 Oct 2026).
  companyPolicies: {
    label: 'Headkey company policies',
    links: [
      { key: 'pricing', label: 'Pricing (all apps)', href: 'https://headkeysoftwaresolution.com/pricing.html' },
      { key: 'terms', label: 'Terms', href: 'https://headkeysoftwaresolution.com/terms.html' },
      { key: 'cookies', label: 'Cookie Policy', href: 'https://headkeysoftwaresolution.com/cookie-policy.html' },
      { key: 'refund', label: 'Refund Policy', href: 'https://headkeysoftwaresolution.com/refund-policy.html' },
    ],
  },
};

export const consentPayload = (c) => ({
  accepted_terms: c.terms === true,
  accepted_privacy: c.privacy === true,
  terms_version: LEGAL.termsVersion,
  privacy_version: LEGAL.privacyVersion,
});
